export const getElementTopOffset = (errorField: any) => {
    let top = 0;
    let element = errorField;

    while (element) {
        top += element.offsetTop || 0;
        element = element.offsetParent;
    }

    return top;
};
